import { StaffRequestView } from 'utils/ManagementEndpointRequest/TimelineSocket'

export const getCity = () => {
  return StaffRequestView.get(`/v1/cities`)
}
export const getSalons = () => {
  return StaffRequestView.get(`/v1/salons`)
}
